<script>
  import Checkbox from "../components/HTMLElements/CheckBoxInput.svelte";
  import Radio from "../components/HTMLElements/RadioInput.svelte";
  import Modal from "../components/HTMLElements/Modal.svelte";
  import Confirm from "../components/HTMLElements/ModalConfirm.svelte";
  import wrappedFetch from "../wrappedFetch.js";
  import { createEventDispatcher } from "svelte";
  const dispatch = new createEventDispatcher();
  export let id;
  export let applicationId;
  let showModal = false;
  let modalScrollElement;
  let acceptOffer;
  let isAcceptClicked = false;
  let offer;
  export let radioParams = { item: [{ value: true, TextValue: "Yes" },{ value: false, TextValue: "No" }], required: true };
  let acceptQuestions = [];
  let declineQuestions = [];
  let acceptAnswers = [];
  let declineAnswers = [];
  let acceptTerms = false;
  let acceptTermsLabel = '';
  let termsUrl = "";
  let reason = "";
  let question1 = 'aacept1', question2 = '', question3 = 'accept3', question4 = '', question5 = '', question6 = 'accept6';
  let answer1 = '', answer2 = '', answer3 = '', answer4 = '', answer5 = '', answer6 = '';
  let error = "";
  let updatingReply = false;
  let showConfirmDecline = false;
  let reasonText;

  const getApplicationDetails = () => {
    return wrappedFetch(
      "application/readOffer?applicationId=" + applicationId,
      { method: "post" }
    )
      .then(response => response.json())
      .then(result => {
        offer = result;
        if (!offer.isOfferVisible) {
          dispatch("pageRedirect", { url: '/user/home/' });
          return;
        }
        acceptQuestions = offer.acceptQuestions;
        declineQuestions = offer.declineQuestions;

        termsUrl = (isAcceptClicked && !acceptTerms && (offer.declineTCUrl != "" || offer.declineTCUrl != null)) ? offer.declineTCUrl : offer.acceptTCUrl;
        acceptTermsLabel = 'I have read and accepted ' + offer.borough.displayName + '<a href="' + termsUrl + '" id="acceptTermsUrl" target = "_blank""> offer terms and conditions</a>';

        if (offer && offer.offeredSchool) {
          if (offer.offeredSchool.laAnswer1 && offer.offeredSchool.laAnswer1 == "Y") answer1 = offer.offeredSchool.status == "A" ? acceptQuestions[0].question : declineQuestions[0].question;
          if (offer.offeredSchool.laAnswer2 && offer.offeredSchool.laAnswer2 == "Y") answer2 = offer.offeredSchool.status == "A" ? acceptQuestions[1].question : declineQuestions[1].question;
          if (offer.offeredSchool.laAnswer3 && offer.offeredSchool.laAnswer3 == "Y") answer3 = offer.offeredSchool.status == "A" ? acceptQuestions[2].question : declineQuestions[2].question;
          if (offer.offeredSchool.laAnswer4 && offer.offeredSchool.laAnswer4 == "Y") answer4 = offer.offeredSchool.status == "A" ? acceptQuestions[3].question : declineQuestions[3].question;
          if (offer.offeredSchool.laAnswer5 && offer.offeredSchool.laAnswer5 == "Y") answer5 = offer.offeredSchool.status == "A" ? acceptQuestions[4].question : declineQuestions[4].question;
          if (offer.offeredSchool.laAnswer6 && offer.offeredSchool.laAnswer6 == "Y") answer6 = offer.offeredSchool.status == "A" ? acceptQuestions[5].question : declineQuestions[5].question;
          reason = offer.offeredSchool.reason || '';
        }

        return result;
      });
  };

  const cancelReply = () => {
    _paq.push(['trackEvent', 'Offer Reply', `Cancelled`]);
    acceptOffer = null;
    isAcceptClicked = false;
    error = "";
    acceptTerms = false;
    acceptAnswers = [];
    declineAnswers = [];
    showModal = false;
  }

  const validateReply = () => {
    error = "";
    if (!isAcceptClicked) {
      error += "You must either accept or decline the offer <br/>";
    }
    // Only mandatory when the LA has set decline answers as required
    // (AcceptDeclineRequired = 'Y' -> isDeclineAnswerRequired), as the server checks.
    if (!acceptOffer && offer.isDeclineAnswerRequired && declineQuestions.length > 0 && !declineAnswers.some(a => a == true)) {
      error += "You must select a reason for declining<br/>";
      modalScrollElement.scrollTop = modalScrollElement.scrollHeight;
    }
    if (termsUrl && termsUrl != "" && !acceptTerms) {
      error += "You must accept the offer terms and conditions <br/>";
    }

    if (error == "") {
      if (!acceptOffer)
        showConfirmDecline = true;
      else
        submitReply();
    }
  }

  const submitReply = () => {
    _paq.push(['trackEvent', 'Offer Reply', `Submitted`]);
    let reply = {};
    reply.applicationId = parseInt(applicationId);
    reply.offerId = offer.id;
    reply.schoolId = offer.offeredSchool.id;
    let answers = (isAcceptClicked && acceptOffer) ? acceptAnswers : (isAcceptClicked && !acceptOffer) ? declineAnswers : null;
    reply.status = (isAcceptClicked && acceptOffer) ? 'A' : (isAcceptClicked && !acceptOffer) ? 'C' : null;
    reply.reason = reason;
    reply.accepted = (isAcceptClicked && acceptOffer) ? 'Y' : (isAcceptClicked && !acceptOffer) ? 'N' : null;
    reply.isAcceptAnswerRequired = offer.isAcceptAnswerRequired;
    reply.isDeclineAnswerRequired = offer.isDeclineAnswerRequired;
    if (answers && answers.length > 0) {
      answers = answers.map(answer => { return answer ? 'Y' : 'N' });
      answers.forEach((a, i) => {
        if (i == 1) reply.answer1 = a;
        if (i == 2) reply.answer2 = a;
        if (i == 3) reply.answer3 = a;
        if (i == 4) reply.answer4 = a;
        if (i == 5) reply.answer5 = a;
        if (i == 6) reply.answer6 = a;
      });
    }
    updatingReply = true;
    wrappedFetch(`/application/offerReply`, {
      method: "post",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(reply)
    })
      .then(response => response.json())
      .then(res => {
        if (res.success) {
          offerPromise = getApplicationDetails();
          showModal = false;
        } else {
          error = res.message;
        }
        updatingReply = false;
      });
  }

  let offerPromise = getApplicationDetails();

  $: {
    if (reason) {
      if (!reasonText)
        reasonText = reason;
      if (reason.length > 1000)
        reason = reason.substring(0, 1000);
    }
  }

  const textAreaValue = (e) => {
    reasonText = e.target.value;
  }
</script>

<svelte:head>
  <title>Application Outcome</title>
</svelte:head>

{#await offerPromise then offer}
  {#if offer}
    <section class="section">
      <div class="container">
        <div class="columns is-centered is-desktop">
          <div class="column is-10-desktop">
            <div class="field">
              <a href="/user/home">
                <span class="fas fa-arrow-left" />
                Back
              </a>
            </div>
            <div class="tile is-parent" style="padding: 0rem;">
              <h1 class="title" style="color: #70457a;">Application Outcome</h1>
            </div>

            <br />
            <div class="level">
              <div class="level-left">
                <a
                  class="level-item jing-offer"
                  href={offer.borough.url}
                  target="_blank"
                  style="margin-right:15px;">
                  <img
                    src={"images/logos/logo_" + offer.laId + ".jpg"}
                    border="0"
                    alt={offer.borough.displayName} />
                </a>
                <div>
                  <p style="margin-bottom: 0px;">
                    <a href={offer.borough.url} target="_blank">
                      {offer.borough.displayName}
                    </a>
                  </p>
                  <p style="margin-bottom: 0px;">
                    <a href="tel:{offer.borough.phasePhone}">{offer.borough.phasePhone}</a>
                  </p>
                  <p style="margin-bottom: 0px;">
                    <a href="mailto:{offer.borough.phaseEmail}">
                      {offer.borough.phaseEmail}
                    </a>
                  </p>
                </div>
              </div>
              <div class="level-right">
                <div class="level-item jing-offer">
                  <p>
                    Application Reference:
                    <strong>{offer.reference}</strong>
                    <br />
                    Child Name:
                    <strong>{offer.childName}</strong>
                    <br />
                    Child Date of Birth:
                    <strong>{offer.dobStr}</strong>
                  </p>
                </div>
              </div>
            </div>

            {#if offer.offeredSchool}
              <div id="showSchool">
                <div>
                  <p>
                    The above child has been offered a place at:
                    <br />
                    <strong>{offer.offeredSchool.name}</strong>
                  </p>
                </div>
              </div>
            {/if}
            {#if offer.borough.acceptUrl != ""}
              <a href={offer.borough.acceptUrl} target="_blank">{offer.borough.name}appeals website </a>
            {/if}
            <br />
            <h4 class="title is-5" style="text-decoration: underline;">
              Information relating to outcome
            </h4>
            <div style="text-align: justify; font-size:1rem;">
              {@html offer.boroughSpecificContent}
              <br />
            </div>
            {#if offer.showOnlineAccept}
              <input
                type="button"
                name="continue"
                id="continue"
                value="Reply"
                class="button is-primary"
                on:click={() => showModal = true} />
            {/if}
            {#if offer.showPostAccept}
              <div class="box" style=" background-color: #fafafa;">
                <p style="margin-bottom: 0px !important;">
                  <span>
                    <span>
                      {@html offer.boroughSpecificPostAccept}
                      {#if answer1 != "" || answer2 != "" || answer3 != "" || answer4 != "" || answer5 != "" || answer6 != "" || reason != ""}
                        <br />
                        <p> Please note, you have selected the following answers or entered text into the comments field:</p>
                        <ul>
                          {#if answer1 != ""} <li>{@html answer1} </li> {/if}
                          {#if answer2 != ""} <li>{@html answer2}</li> {/if}
                          {#if answer3 != ""} <li>{@html answer3} </li> {/if}
                          {#if answer4 != ""} <li>{@html answer4} </li>{/if}
                          {#if answer5 != ""} <li>{@html answer5}</li>{/if}
                          {#if answer6 != ""} <li>{@html answer6}</li>{/if}
                          {#if reason != ""} <li>{@html reason.replace('\n', '<br/>')}</li>{/if}
                        </ul>
                      {/if}
                    </span>
                  </span>
                </p>
              </div>
            {/if}
          </div>
        </div>
      </div>
    </section>

    <Modal bind:showModal={showModal} allowClose={false} bind:scrollElement={modalScrollElement}>
      <div id="showOnlineAccept_0" style="text-align: justify; font-size:1rem;">

        <h4 class="title is-4">Reply to offer</h4>
        {@html offer.boroughSpecificAcceptanceContent || ''}

        <hr />
        <div class="field">
          <strong>
            Do you want to accept this offer for {offer.offeredSchool ? offer.offeredSchool.name : ""}?
          </strong>
        </div>
        <Radio
          bind:group={acceptOffer}
          label="accept offer"
          errorMessage="You must select accept offer."
          {...radioParams}
          bind:isDirty={isAcceptClicked}
          on:changed={() => error = ""} />

        <br />
        <div class="field">You must reply before {offer.acceptDateStr}</div>

        <div id="questionWrapper">
          {#if isAcceptClicked}
            <div class="field has-text-danger"> Please remember to submit your reply</div>
            {#if acceptOffer && acceptQuestions.length > 0}
              {#each acceptQuestions as q}
                <Checkbox label={q.question} bind:checked={acceptAnswers[q.id]} />
              {/each}
            {:else if !acceptOffer && declineQuestions.length > 0}
              <p><strong>Please select one reason</strong></p>
              {#each declineQuestions as q}
                <Checkbox
                  label={q.question}
                  bind:checked={declineAnswers[q.id]}
                  on:change={() => {
                    if (declineAnswers[q.id]) {
                      declineQuestions.forEach(other => {
                        if (other.id !== q.id) declineAnswers[other.id] = false;
                      });
                      declineAnswers = declineAnswers; // trigger Svelte reactivity
                    }
                  }}
                />
              {/each}
            {/if}
          {/if}
          <label class="label">Relevant Comments</label>
          <textarea
            name="reason"
            bind:value={reason}
            id="reason"
            on:input={textAreaValue} on:blur={() => { reason = reasonText }}
            rows="5"
            style="width: 100%;"
            maxlength="1000" />
          <p style="font-size:0.8rem;">({reasonText == null ? reason ? reason.length : 0 : reasonText.length} of 1000 characters used)</p>
          {#if termsUrl && termsUrl != ""}
            <Checkbox label={acceptTermsLabel} bind:checked={acceptTerms} />
          {/if}
          {#if error != ""}
            <div class="notification is-invalid"><p class="is-danger">{@html error}</p></div>
          {/if}
        </div>
      </div>
      <footer class="modal-card-foot buttons is-right" slot="footer">
        <button class="button continue" on:click={cancelReply}>
          Cancel
        </button>
        <button class="button is-primary continue" on:click={validateReply}>
          Submit reply
        </button>
      </footer>
    </Modal>

    <Modal bind:showModal={showConfirmDecline}>
      <div style="padding:1.5rem">Are you sure you want to decline this offer?</div>
      <footer class="modal-card-foot buttons is-right" slot="footer">
        <button
          class="button is-primary"
          on:click={() => {
            showConfirmDecline = false;
            submitReply();
          }}>
          Yes
        </button>
        <button class="button is-purple" on:click={() => showConfirmDecline = false}>
          No
        </button>
      </footer>
    </Modal>
  {/if}
{/await}